export default {
  placeholder: 'Søg restaurant...',
};
